<template>
    <master-layout>
        <div class="breadcamb_box">
            <div>
                <h4 class="page-title"><i class="ti-bar-chart"></i> {{ $t('deals_report') }}</h4>
            </div>
            <pml-back-button></pml-back-button>
        </div>

        <div class="row">
            <div class="col-md-12">
                <PmlProjection></PmlProjection>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <PmlPerceptions></PmlPerceptions>
            </div>
            <div class="col-md-6">
                <PmlOpenDealsByMember></PmlOpenDealsByMember>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <PmlByConsultant :is-loading="isLoading" :table-data="byConsultant"></PmlByConsultant>
            </div>
        </div>
    </master-layout>
</template>

<script>
    import PmlByConsultant from './ByConsultant.vue'
    import PmlOpenDealsByMember from './OpenDealsByMember.vue'
    import PmlPerceptions from './Perceptions.vue'
    import PmlProjection from './Projection.vue'
    import { getDealsReport } from 'services/reports'
    import { trans } from 'utils/helpers/translation'

    export default {
        name: 'DealsReport',
        components: {
            PmlOpenDealsByMember,
            PmlPerceptions,
            PmlProjection,
            PmlByConsultant
        },
        metaInfo () {
            return {
                title: trans('deals_report')
            }
        },
        data () {
            return {
                byConsultant: false,
                isLoading: false,
                errors: []
            }
        },
        mounted () {
            this.doFilter()
        },
        methods: {
            doFilter () {
                this.isLoading = true

                getDealsReport()
                    .then(response => {
                        this.byConsultant = response.data.overview
                    })
                    .catch(error => {
                        this.errors = error.response.data.errors || []
                    })
                    .then(() => { this.isLoading = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/reports/deals/components/Main.vue